<button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
        <mat-menu #menu="matMenu">
          <mat-form-field appearance="fill" (click)="$event.stopPropagation();$event.preventDefault();">
            <mat-label>Select Role</mat-label>
            <select matNativeControl required>
              <option value="saab">Attendee</option>
              <option value="mercedes">Note taker</option>
              <option value="audi">Faciliator</option>
              <option value="audi">Chairperson</option>
              <option value="audi">Faciliator</option>
            </select>
          </mat-form-field>
            <!-- <button mat-menu-item>
              <mat-icon>dialpad</mat-icon>
              <span>Redial</span>
            </button> -->
            <button mat-menu-item disabled>
              <mat-icon>voicemail</mat-icon>
              <span>Check voice mail</span>
            </button>
            <button mat-menu-item>
              <mat-icon>notifications_off</mat-icon>
              <span>Disable alerts</span>
            </button>
        </mat-menu>